import { render, staticRenderFns } from "./gatePass.vue?vue&type=template&id=5b12fe46&"
import script from "./gatePass.vue?vue&type=script&lang=js&"
export * from "./gatePass.vue?vue&type=script&lang=js&"
import style0 from "./gatePass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports